export const ARTICLE_TEXT_SIZE = {
  NORMAL: 'normal',
  LARGE: 'large',
  LARGEST: 'largest'
}

export const ACCESSIBILITY_TEXT_SIZE_STORAGE_KEY = 'atssk'
